var site = site || {};
// eslint-disable-next-line no-use-before-define
var prodcat = prodcat || {};

prodcat.data = prodcat.data || {};

(function ($) {
  Drupal.behaviors.pdpBundleItemV1 = {
    $items: $(),
    $bundle: $(),
    $pdpProduct: $(),
    settings: {},
    attach: function (context, settings) {
      var self = this;
      if (self.attached) {
        return;
      }
      self.attached = true;
      self.settings = settings;
      self.getMainDom(context);

      self.$items.each(function() {
        var $this = $(this);
        self.getDom($this);
        self.toggleAddToBag($this);
        self.setEvents($this);
        self.setup($this);
      });
      self.updateBundleCta();
      setTimeout(function() {
        // Allow Add to bag listeners time to be set.
        self.updateBundle();
      }, 300);
    },
    getMainDom: function (context) {
      var self = this;
      self.$items = $('.js-pdp-bundle-item', context);
      self.$bundle = $('.js-product-bundle', context);
      self.$pdpProduct = $('.js-spp-content', context);
      self.$pdpProduct.nodes = {};
      self.$pdpProduct.nodes.$addToBag = $('.js-product-add-to-bag', self.$pdpProduct);
      self.$pdpProduct.nodes.$statusList = $('.js-product-inventory-status-list', self.$pdpProduct);
      self.$pdpProduct.nodes.$soldOutStatus = $('.product-inventory-status--7', self.$pdpProduct.nodes.$statusList);
    },
    getDom: function ($that) {
      $that.nodes = {};
      $that.nodes.$shadeDropdown = $('.js-shade-select', $that);
      $that.nodes.$shadeOptions = $('.js-shade-select-option', $that);
      $that.nodes.$shadeLabelText = $('.js-shade-select-label-text', $that);
      $that.nodes.$shadeLabelColor = $('.js-shade-select-label-color', $that);
      $that.nodes.$image = $('.js-pdp-bundle-item--media-image', $that);
      $that.nodes.$sppLinks = $('.js-pdp-bundle-item__link-to-spp', $that);
      $that.nodes.$shadeDescription = $('.js-pdp-bundle-item--shade-description', $that);
      $that.nodes.$addToBag = $('.js-product-add-to-bag', $that);
      $that.nodes.$sizePicker = $('.js-size-select--dropdown', $that);
      $that.nodes.$statusList = $('.js-product-inventory-status-list', $that);
      $that.nodes.$notifyMe = $('.js-notify_me_inventory_status--2', $that);
      $that.nodes.$soldOutStatus = $('.product-inventory-status--7', $that.nodes.$statusList);
    },
    setEvents: function ($that) {
      var self = this;
      $that.nodes.$shadeOptions.once('bundle-shades').on('shades-dropdown-selected', function() {
        var $this = $(this);
        var shadeHex = $this.data('hex');
        var shadeName = $this.data('shadeName');
        $this.addClass('selected');
        $that.nodes.$shadeLabelColor.css('background-color', shadeHex);
        $that.nodes.$shadeLabelText.html(shadeName);
        self.updateSku($that, $this.data('skuId'));
      });
      $that.nodes.$sizePicker.once('bundle-sizes').on('change', function () {
        var selectedSkuId = $(this).val();

        self.updateSku($that, selectedSkuId);
      });

      $(document).on('productBundle.updateProducts product.updateInvStatus', '.js-product-ui', function () {
        var $product = $(this);
        if (!$product.is($that)) {
          return;
        }
        var skuBaseId = $product.data('sku-base-id');
        var skuDataL2 = prodcat.data.getSku(skuBaseId);
        var availableSkuDataL2 = skuDataL2 !== null ? self.setAvailableSku(skuDataL2) : '';
        var availableSkuBaseId = availableSkuDataL2.SKU_BASE_ID ?? skuBaseId;

        if ($product.hasClass('js-pdp-bundle-item') && !$product.hasClass('inv-changed')) {
          $product.attr({
            'data-sku-base-id': availableSkuDataL2.SKU_BASE_ID,
            'data-sku-id': availableSkuDataL2.SKU_ID,
            'data-sku-inv-status': availableSkuDataL2.INVENTORY_STATUS
          });
          $product.data({
            'skuBaseId': availableSkuDataL2.SKU_BASE_ID,
            'skuId': availableSkuDataL2.SKU_ID,
            'skuInvStatus': availableSkuDataL2.INVENTORY_STATUS
          });
          self.updateSoldoutMessage($product);
          self.updateBundleCta();
          self.updateBundle();
          self.updateAddToBag($product, availableSkuBaseId);
          self.updateNotifyMe($product, availableSkuBaseId);
          $product.trigger('product.selectCustomShade', availableSkuBaseId);
          $product.trigger('productBundle.skuSelect', availableSkuBaseId);
        }
      });

      $(window).on('pageshow', function () {
        $that.each(function () {
          $(this).trigger('productBundle.updateProducts');
        });

        self.$bundle.addClass('product-bundle-loaded');
      });
    },
    setup: function ($that) {
      if (Drupal.settings.globals_variables.hide_cross_sell_installment_price) {
        $that.find('.js-product-price-installment').addClass('hidden');
      }

      if (Drupal.settings.globals_variables.highlight_cross_sell_sale_price) {
        $that.addClass('pdp-bundle-item--highlight-sale-price');
      }

      if ($that.nodes.$sizePicker.length > 0) {
        const skuBaseId = $that.nodes.$sizePicker.filter('select').val();

        setTimeout(function () {
          // Allow listener time to be set.
          $that.trigger('productBundle.skuSelect', parseInt(skuBaseId));
        }, 0);
      }
    },
    updateSku: function ($that, skuId) {
      var self = this;
      var skuData = prodcat.data.getSku(skuId);
      var imageIndex = $that.data('imageIndex') ? $that.data('imageIndex') - 1 : 1;
      var src = '';
      var description = '';
      var availableSkuData;
      if (!skuData) {
        return;
      }

      availableSkuData = self.setAvailableSku(skuData);

      $that.attr({
        'data-sku-base-id': availableSkuData.SKU_BASE_ID,
        'data-sku-id': availableSkuData.SKU_ID,
        'data-sku-inv-status': availableSkuData.INVENTORY_STATUS
      });
      $that.data({
        'skuBaseId': availableSkuData.SKU_BASE_ID,
        'skuId': availableSkuData.SKU_ID,
        'skuInvStatus': availableSkuData.INVENTORY_STATUS
      });
      // Update Image.
      src = availableSkuData.IMAGE_LARGE[imageIndex] || availableSkuData.IMAGE_LARGE[1];

      if ($that.nodes.$image.length > 0) {
        $that.nodes.$image.attr('src', src);
      }

      // Update Shade description.
      description = availableSkuData.SHADE_DESCRIPTION || '';
      $that.nodes.$shadeDescription.html(description);

      self.updateSoldoutMessage($that);
      self.updateRoute($that, availableSkuData.SKU_BASE_ID);
      self.updateAddToBag($that, availableSkuData.SKU_BASE_ID);
      self.updateNotifyMe($that, availableSkuData.SKU_BASE_ID);

      if ($that.nodes.$addToBag.length < 1) {
        // If we have add to bag on bundle, we don't alter main page add to bag.
        self.updateBundle();
        self.updateBundleCta();
      }
    },
    updateRoute: function ($that, skuId) {
      var url = $that.nodes.$sppLinks.first().attr('href');
      var newRoute = site.getRouteUrl($that, skuId, '');

      if (url.indexOf('?') >= 0) {
        url = url.split('?')[0] + newRoute;
      } else {
        url = url + newRoute;
      }
      !!newRoute && $that.nodes.$sppLinks.attr('href', url);
    },
    updateNotifyMe: function ($that, skuBaseId) {
      var $notifyMe = $that.nodes?.$notifyMe?.find('.js-notify-me');

      if ($notifyMe?.length > 0) {
        $notifyMe.attr('data-sku-base-id', skuBaseId);
      }
    },
    updateAddToBag: function ($that, skuBaseId) {
      var self = this;

      if ($that.nodes?.$addToBag?.length > 0) {
        $that.nodes.$addToBag.attr('data-sku-base-id', skuBaseId);
        self.toggleAddToBag($that);
      }
    },
    updateSoldoutMessage: function ($that) {
      var $soldoutMessageContainer = $that.find('.js-pdp-bundle-item--soldout-message');
      var skuInvetoryStatus = $that.data().skuInvStatus;

      $soldoutMessageContainer.addClass('hidden');
      if (skuInvetoryStatus === 7) {
        $soldoutMessageContainer.removeClass('hidden');
      }
    },
    setAvailableSku: function (skuData) {
      var self = this;
      var newSkuData;
      var skuShoppableData;
      var prodData;

      if (!skuData) {
        return;
      }

      newSkuData = skuData;

      if (self.$bundle.hasClass('product-bundle-loaded')) {
        return newSkuData;
      }

      prodData = prodcat.data.getProduct(skuData.PRODUCT_ID);

      if (skuData.INVENTORY_STATUS === 7) {
        // Find and return an available sku
        skuShoppableData = _.filter(prodData.skus, function (i) {
          if ((i.INVENTORY_STATUS === 1) || (i.INVENTORY_STATUS === 3)) {
            return i;
          }
        });

        newSkuData = skuShoppableData[0] || prodData.skus[0];

      } else {
        newSkuData = skuData;
      }

      return newSkuData;
    },
    toggleAddToBag: function ($that) {
      var self = this;

      if ($that.nodes?.$addToBag?.length < 1) {
        return;
      }
      var isSoldOut = self.isInvalidInvStatus($that);
      var wasSoldOut = $that.nodes.$addToBag.parent().hasClass('hidden');
      var toggleSoldOut = (!isSoldOut && wasSoldOut) || (isSoldOut && !wasSoldOut);

      if (toggleSoldOut) {
        $that.nodes.$addToBag.parent().toggleClass('hidden', isSoldOut);
        self.toggleBundleItemInvStatus($that, isSoldOut);
      }
    },
    toggleBundleItemInvStatus: function ($that, isSoldOut) {
      var self = this;
      const invStatus = $that.attr('data-sku-inv-status');

      if (!isSoldOut) {
        $that.nodes.$notifyMe.hide();
        $that.nodes.$statusList.hide();
        $that.nodes.$statusList.parent().addClass('hidden');
        $that.nodes.$soldOutStatus.hide();

        return;
      }

      if (invStatus === '2' && self.settings.globals_variables.notify_display_tempoos) {
        $that.nodes.$notifyMe.show();
      }
      if (invStatus === '7') {
        $that.nodes.$statusList.show();
        $that.nodes.$statusList.parent().removeClass('hidden');
        $that.nodes.$soldOutStatus.show();
      }
    },
    updateBundle: function ($products) {
      var self = this;
      var $items = $products || self.$items;
      var skuBaseIds = [];

      $items.each(function () {
        var $this = $(this);
        skuBaseIds.push($this.attr('data-sku-base-id'));
      })
      self.$bundle.trigger('product.bundleSelect', skuBaseIds.join(', '));
    },
    updateBundleCta: function ($products) {
      var self = this;
      var $items = $products || self.$items;
      var isSoldOut = false;
      var wasSoldOut = self.$pdpProduct.nodes.$addToBag.parent().hasClass('hidden');

      $items.each(function () {
        var $this = $(this);
        isSoldOut = isSoldOut || self.isInvalidInvStatus($this);
      });
      var toggleSoldOut = (!isSoldOut && wasSoldOut) || (isSoldOut && !wasSoldOut);

      if (self.$bundle.length < 1) {
        // If it's not a bundle, don't update main CTA.
        return;
      }
      if (toggleSoldOut) {
        self.$pdpProduct.nodes.$addToBag.parent().toggleClass('hidden');
        // Hide all other statuses and show the right one.
        if (self.$pdpProduct.nodes.$soldOutStatus.length > 0) {
          self.$pdpProduct.nodes.$statusList.toggle();
          self.$pdpProduct.nodes.$statusList.parent().toggle();
          self.$pdpProduct.nodes.$soldOutStatus.toggle();
        }
      }
    },
    isInvalidInvStatus: function($that) {
      var self = this;
      var invStatus = $that.attr('data-sku-inv-status');
      var isInvalidStatus = invStatus !== '1';
      if (invStatus === '2') {
        isInvalidStatus = self.settings.globals_variables.notify_display_tempoos;
      }
      return isInvalidStatus;
    },

    attached: false
  };
})(jQuery);
